{
  "reactions": {
    "react": "Reagoi",
    "like": "Tykkää",
    "fire": "Tuli",
    "clap": "Taputus",
    "trophy": "Pokaali",
    "muscle": "Lihas",
    "failed_to_add": "Reaktion lisääminen epäonnistui",
    "who_reacted": "Reaktiot",
    "all": "Kaikki",
    "no_reactions": "Ei vielä reaktioita",
    "total": "{{count}} reaktiota"
  },
  "comments": {
    "title": "Kommentit",
    "write_comment": "Kirjoita kommentti...",
    "write_reply": "Kirjoita vastaus...",
    "post_comment": "Lähetä kommentti",
    "reply": "Vastaa",
    "replies": "vastausta",
    "no_comments": "Ei vielä kommentteja. Ole ensimmäinen kommentoija!",
    "comment_posted": "Kommentti lähetetty",
    "reply_posted": "Vastaus lähetetty",
    "failed_to_post": "Kommentin lähettäminen epäonnistui",
    "comment_deleted": "Kommentti poistettu",
    "failed_to_delete": "Kommentin poistaminen epäonnistui",
    "confirm_delete": "Haluatko varmasti poistaa tämän kommentin?",
    "confirm_delete_header": "Poista kommentti"
  }
}
